import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './GetYourGuideWidget.module.css';
import { GYG_LOCATION_IDS } from './gygLocations';

const GYG_PARTNER_ID = 'YDBYIYO';

export const getLocationIdFromAddress = (address) => {
  if (!address) return null;

  const searchText = address.toLowerCase();

  // Try exact match first
  if (GYG_LOCATION_IDS[searchText]) {
    return GYG_LOCATION_IDS[searchText];
  }

  // Try partial match - check if any location name is in the search
  for (const [locationName, locationId] of Object.entries(GYG_LOCATION_IDS)) {
    if (searchText.includes(locationName) || locationName.includes(searchText)) {
      return locationId;
    }
  }

  return null;
};

const GetYourGuideWidget = props => {
  const { className, rootClassName, searchAddress, widgetType } = props;
  const classes = classNames(rootClassName || css.root, className);

  const locationId = getLocationIdFromAddress(searchAddress);

  // Don't render if no location found
  if (!locationId) {
    return null;
  }

  // GYG script is loaded globally in Page.js head
  return (
    <div className={classes}>
      <div
        key={locationId}
        className={css.widget}
        data-gyg-href="https://widget.getyourguide.com/default/city.frame"
        data-gyg-location-id={locationId}
        data-gyg-locale-code="en-US"
        data-gyg-widget={widgetType}
        data-gyg-partner-id={GYG_PARTNER_ID}
      />
    </div>
  );
};

GetYourGuideWidget.defaultProps = {
  className: null,
  rootClassName: null,
  searchAddress: null,
  widgetType: 'city',
};

GetYourGuideWidget.propTypes = {
  className: string,
  rootClassName: string,
  searchAddress: string,
  widgetType: string,
};

export default GetYourGuideWidget;
